export const bookingPresenceTranslations = {
  PRESENT: 'bookings:common.presence.confirmed',
  ABSENT: 'bookings:common.presence.notConfirmed',
} as const;
